import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadReports,
  passProfileOrEvent,
  failProfile,
  failEvent
} from "../../redux/actions/reportActions";
import Comment from "./Comment";

export default function AdminTrial() {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const [reportList, setReportList] = useState([]);
  const reports = useSelector(state => state.reports);
  const [adminReason, setAdminReason] = useState("");

  useEffect(() => {
    getReports();
  }, []);

  async function getReports() {
    const accessToken = await getAccessTokenSilently();
    const currentReports = await dispatch(loadReports(accessToken));
    setReportList(buildReportList(currentReports));
    console.log("getReports: ", currentReports);
  }

  function buildReportList(reports) {
    console.log(reports);
    return (reports.map(report =>
      <li className="approval-item" key={report.id}>
        <Link
          className="event-link"
          to={
            report.report_type === "event"
              ? `/event/${report.event_id}`
              : `/profile/${report.profile_id}`
          }
        >
          {report.report_type +
            ": " +
            (report.report_type === "event"
              ? report.event_id
              : report.profile_id)}
        </Link>
        {report.reason != "" && (
          <div className="comment">
            <span className="label">Inskickad kommentar:</span>{" "}
            {report.reason}
          </div>
        )}
        <button
          className="approve"
          type="submit"
          id={report.id}
          onClick={handlePass}
        >Godkänn</button>
        <button
          className="refuse"
          type="submit"
          id={report.id}
          onClick={
            report.report_type === "event"
              ? handleFailEvent
              : handleFailProfile
          }
        >Underkänn</button>
        <Comment comment={adminReason} setComment={setAdminReason} />
      </li>
    ));
  }

  async function handlePass(e) {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(passProfileOrEvent(accessToken, createFormData(e.target.id)));
  }

  async function handleFailProfile (e) {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(failProfile(accessToken, createFormData(e.target.id)));
  }

  async function handleFailEvent (e) {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    dispatch(failEvent(accessToken, createFormData(e.target.id)));
  }

  function createFormData(id) {
    console.log(id);
    const reportItem = reports.find(box => box.id == id);
    console.log(reportItem);
    const formData = {
      id: reportItem.id,
      profile_id: reportItem.profile_id,
      event_id: reportItem.event_id,
      report_type: reportItem.report_type,
      admin_id: localStorage.id,
      admin_reason: adminReason
    };
    console.log(formData);
    return formData;
  }





  return (
    <div className="approval-lists">
      {reportList && reportList.length !== 0 && (
        <div>
          <span>Rapporterat av användare:</span>
          <ul className="approval-list">
            {reportList}
          </ul>
        </div>
      )}
    </div>
  );
}
